import { cva } from '@/styled-system/css';

export const gleamLabelRecipe = cva({
  base: {
    display: 'inline-flex',
    textStyle: 'body-sm-bold',
  },

  variants: {
    tone: {
      default: {},
      info: {},
      new: {},
    },

    floating: {
      true: {
        position: 'absolute',
        right: 'calc({sizes.250} * -1)',
        top: 'calc({sizes.250} * -1)',
      },
      false: {},
    },

    floatingComponent: {
      Avatar: {},
      Icon: {},
    },

    floatingOffset: {
      xs: {},
      sm: {},
      md: {},
      lg: {},
      xl: {},
      xxl: {},
    },

    onImpact: {
      true: {},
      false: {},
    },
    appearance: {
      ellipsis: {
        backgroundColor: 'bg.feedback.notify.hero-fixed',
        borderRadius: 'shape.capsule',
        color: 'text.onHero.neutral-fixed',
        lineHeight: '{sizes.obj.xxs}',
        minWidth: 'obj.xxs',
        paddingLeft: '150',
        paddingRight: '150',
      },
      dot: {
        alignItems: 'center',
        height: 'obj.xxs',
        justifyContent: 'center',
        width: 'obj.xxs',
      },
    },
  },

  compoundVariants: [
    {
      tone: 'info',
      onImpact: false,
      appearance: 'ellipsis',
      css: {
        backgroundColor: 'bg.feedback.info.impact',
        color: 'text.onImpact.neutral',
      },
    },
    {
      tone: 'info',
      onImpact: true,
      appearance: 'ellipsis',
      css: {
        backgroundColor: 'bg.feedback.info.soft',
        color: 'text.feedback.info.strong',
      },
    },
    {
      tone: 'new',
      onImpact: false,
      appearance: 'ellipsis',
      css: {
        backgroundColor: 'Gleam.new.bg',
        color: 'Gleam.new.text',
      },
    },
    {
      tone: 'new',
      onImpact: true,
      appearance: 'ellipsis',
      css: {
        backgroundColor: 'bg.feedback.success.soft',
        color: 'Gleam.onImpact.new.text',
      },
    },
    {
      floating: true,
      floatingComponent: 'Avatar',
      floatingOffset: 'md',
      css: {
        right: 'calc({sizes.200} * -1)',
        top: 'calc({sizes.200} * -1)',
      },
    },
    {
      floating: true,
      floatingComponent: 'Avatar',
      floatingOffset: 'lg',
      css: {
        right: 'calc({sizes.100} * -1)',
        top: 'calc({sizes.100} * -1)',
      },
    },
    {
      floating: true,
      floatingComponent: 'Avatar',
      floatingOffset: 'xl',
      css: {
        right: '{sizes.zero}',
        top: '{sizes.zero}',
      },
    },
    {
      floating: true,
      floatingComponent: 'Avatar',
      floatingOffset: 'xxl',
      css: {
        right: '{sizes.200}',
        top: '{sizes.200}',
      },
    },
    {
      floating: true,
      floatingComponent: 'Icon',
      floatingOffset: 'sm',
      css: {
        right: 'calc({sizes.300} * -1)',
        top: 'calc({sizes.300} * -1)',
      },
    },
    {
      floating: true,
      floatingComponent: 'Icon',
      floatingOffset: 'xl',
      css: {
        right: 'calc({sizes.200} * -1)',
        top: 'calc({sizes.200} * -1)',
      },
    },
  ],
});
